import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
      primary: {
        main: '#5200FF',
      },
    }
  })

  export default theme;